export default "__VITE_ASSET__BdkMr2Yq__"